accordion = {
    init: function () {

        jQuery( '.js-accordion-title' ).click( function ( e ) {
            e.preventDefault();
            if(window.innerWidth <= 991){
                let jQuerythis = jQuery( this );
                if ( jQuerythis.next().hasClass( 'active' ) ) {
                    jQuerythis.next().removeClass( 'active' );
                    jQuerythis.removeClass( 'active' );
                    jQuerythis.next().slideUp( 350 );
                } else {
                    
                    jQuery( '.js-accordion-content' ).removeClass( 'active' );
                    jQuery( '.js-accordion-title' ).removeClass( 'active' );
                    jQuery( '.js-accordion-content' ).slideUp( 350 );
    
                    jQuerythis.next().toggleClass( 'active' );
                    jQuerythis.toggleClass( 'active' );
                    jQuerythis.next().slideToggle( 350 );
                }
            }
        } );

        window.onresize = function(){
            if(window.innerWidth > 992){
                jQuery( '.js-accordion-content' ).removeClass( 'active' );
                jQuery( '.js-accordion-title' ).removeClass( 'active' );
                jQuery( '.js-accordion-content' ).show();
            }else{
                jQuery( '.js-accordion-content' ).hide();
            }
        }
    }
}